import React from 'react';

export default function FilledReservation({ reservation }) {
  const timeTo =
    parseInt(reservation.from, 10) + parseInt(reservation.span, 10);
  const handleReservation = () => {
    alert(
      `Rezervace na jméno ${reservation.name} od ${reservation.from} do ${timeTo}:00 hodin.`
    );
  };
  return (
    <>
      {reservation.permanent ? (
        <div
          className="graph-reservation__filled"
          style={{
            height: reservation.height,
            backgroundColor: '#324554'
          }}
        >
          <span className="graph-reservation__name"> {reservation.name}</span>
        </div>
      ) : (
        <div
          onClick={handleReservation}
          className="graph-reservation__filled"
          style={{
            height: reservation.height,
            backgroundColor: ' #d70b2d'
          }}
        >
          <span className="graph-reservation__name"> {reservation.name}</span>
        </div>
      )}
    </>
  );
}
